import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useNavigationState} from '@react-navigation/native';
import {default as ListItem} from './ClientListItem';
import HeaderBox from './header-box';
import InternalTemplate from '../../../../../../components/templates/internal';
import {IClient} from '../../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../../navigators';
import {SpinnerModal} from '../../../../../../components/modals';
import {EmptyListIcon} from '../../../../../../components/icons';
import {useSalesmanContext} from '../../../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<StackParamList, 'SalesmanClientList'>;

function usePreviousRouteName() {
  return useNavigationState(state =>
    state.routes[state.index - 1]?.name
      ? state.routes[state.index - 1].name
      : 'None',
  );
}

const ClientListScreen = ({navigation}: ScreenProps) => {
  const [filtered, setFiltered] = useState([] as IClient[]);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {clients, fetchClients, setSalesmanClient} = useSalesmanContext();

  const previousRouteName = usePreviousRouteName();

  const getClients = async () => {
    setIsLoading(true);
    setFiltered([]);
    //  REALIZAR EL REFACTORING CONSTRUYENDO EL METODO
    await fetchClients();
    setIsLoading(false);
  };

  useEffect(() => {
    getClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (clients) {
      setFiltered(clients);
    }
  }, [clients]);

  const handleGoBack = () => {
    navigation.navigate('SalesmanDashboard');
  };

  const handleSelectItem = (index: number) => {
    setSalesmanClient(filtered[index]);
    if (previousRouteName === 'SalesmanOrderListFilter') {
      navigation.navigate(
        previousRouteName as
          | 'SalesmanClientDashboard'
          | 'SalesmanOrderListFilter',
      );
    } else {
      navigation.navigate('SalesmanClientDashboard');
    }
  };

  const handleSearchChange = (value: string) => {
    const search = value.trim().toLowerCase();
    setSearchText(search);

    if (search === '') {
      if (clients) {
        setFiltered(clients);
      }
      return;
    }

    if (clients) {
      const filteredClients = clients.filter(client => {
        if (client.name.toLowerCase().indexOf(search) > -1) {
          return true;
        }
        if (client.rif.toLowerCase().indexOf(search) > -1) {
          return true;
        }
      });
      setFiltered(filteredClients);
    }
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const showContent = () => {
    if (isLoading) {
      return <></>;
    }
    if (clients?.length === 0) {
      return <EmptyListIcon />;
    }
    if (filtered) {
      return filtered.map((client: IClient, index: number) => (
        <ListItem
          key={`client-item-${index}`}
          id={client.id}
          onPress={() => handleSelectItem(index)}
          rowType={isOdd(index) ? 'odd' : 'even'}
          name={client.name}
          rif={client.rif}
          balance={client.balance}
          priceOptionList={[]}
        />
      ));
    }

    return <></>;
  };

  return (
    <InternalTemplate
      title={'screen-salesman-client-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box paddingX={5}>
        <HeaderBox
          onChangeSearch={handleSearchChange}
          count={filtered.length}
          searchText={searchText}
        />
      </Box>
      <Box marginBottom={20}>{showContent()}</Box>
    </InternalTemplate>
  );
};
export default ClientListScreen;
